import "./index.less";
import classNames from "classnames";
import React, {
  PropsWithChildren,
  ReactNode,
  CSSProperties,
  useState,
  useEffect,
} from "react";
import DialogPlusHead from "./DialogDefaultHead/dialogPlusHead";
import SpinUI from "../Spin";
import ResultUI from "../Result";
import EmptyUI from "../Empty";
import { useDialogPlus } from "../Dialog/dialogPlus";
import { hasLoadingData, isLoadingDataEmpty } from "../loadingStateData";

export interface DialogPlusPageProps {
  className?: string;
  /**必传 用于关闭指定弹窗标识*/
  dialogName: string;
  presentation?: "page" | "modal-card";

  header?: ReactNode;

  title?: string;

  headExtra?: ReactNode;

  style?: any;

  /**固定头部  */
  fixedHeader?: ReactNode;

  isLoading?: boolean;
  error?: any;
  dataList?: any;
  retryFunc?: () => void;
  childrenStyle?: CSSProperties;
  delayTime?: number;
  dialogScrollId?: any;

  /**是否隐藏关闭按钮 */
  isHideClose?: boolean;

  /**是否显示M-pesa支付提示 */
  showMpesaTip?: boolean;
}

const DialogPlusPage = (props: PropsWithChildren<DialogPlusPageProps>) => {
  const {
    children,
    dialogName,
    header,
    title,
    headExtra,
    className,
    style,
    presentation = "page",
    fixedHeader,
    dialogScrollId,
    isLoading,
    error,
    dataList,
    retryFunc,
    childrenStyle,
    delayTime = 300,
    isHideClose,
    showMpesaTip = false,
  } = props;
  const prefixCls = "dialog-plus-page";

  const showHead = typeof header === "undefined";
  const { stopClose } = useDialogPlus();
  const isLoadingControlled = typeof isLoading !== "undefined";
  const [delayLoading, setDelayLoading] = useState<boolean>(
    () => isLoadingControlled && Boolean(isLoading)
  );
  const hasDataList = hasLoadingData(dataList);
  const isDataListEmpty = isLoadingDataEmpty(dataList);
  const shouldShowContent =
    !delayLoading && !error && (hasDataList || !isLoadingControlled);
  useEffect(() => {
    if (!isLoadingControlled) {
      setDelayLoading(false);
    }
  }, []);

  useEffect(() => {
    let timer;
    if (isLoadingControlled) {
      if (!isLoading) {
        timer = setTimeout(() => {
          setDelayLoading(false);
        }, delayTime);
      } else {
        setDelayLoading(true);
      }
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [isLoading, error, dataList]);

  const spinUiStyle = {
    display: "flex",
    justifyContent: "center",
  };

  return (
    <div
      data-dialog-presentation={presentation}
      style={style}
      className={classNames([prefixCls, className])}
      onMouseDown={() => {
        stopClose();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {showHead ? (
        <DialogPlusHead
          dialogName={dialogName}
          title={title}
          extra={headExtra}
          isHideClose={isHideClose}
        />
      ) : (
        header
      )}

      {delayLoading && (
        <div className={classNames([`${prefixCls}-loading`])}>
          <div>
            {showMpesaTip && (
              <div
                style={{
                  marginBottom: "16px",
                  textAlign: "center",
                  color: "#666",
                }}
              >
                <div>Sending request, please wait...</div>
                <div>Please check your phone！</div>
              </div>
            )}
            <SpinUI
              style={spinUiStyle}
              className={`${prefixCls}-spin-ui`}
              dot
              block
              loading={delayLoading}
            />
          </div>
        </div>
      )}
      {!delayLoading && error && (
        <div className={`${prefixCls}-loading`}>
          <ResultUI errorCode={error?.code} retryFunc={retryFunc} />
        </div>
      )}
      {!delayLoading &&
        !error &&
        !isLoading &&
        isDataListEmpty &&
        isLoadingControlled && (
          <div className={`${prefixCls}-loading`}>
            <EmptyUI showIcon={false} description={"NoData"} />
          </div>
        )}

      {fixedHeader && (
        <div
          className={classNames([
            `${prefixCls}-fixed-header`,
            shouldShowContent ? `${prefixCls}-fixed-header-loaded` : "",
          ])}
        >
          {fixedHeader}
        </div>
      )}
      {shouldShowContent && (
        <div
          className={classNames([
            `${prefixCls}-scorllview`,
            `${prefixCls}-scorllview-loaded`,
          ])}
          style={childrenStyle}
          id={dialogScrollId}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default DialogPlusPage;
